// extracted by mini-css-extract-plugin
export default {"wrapper":"In-z","response":"Jn-z","error":"Kn-z","disabled":"Ln-z","buttons":"Mn-z","feedbackQuestionSection":"Nn-z","yesNoWrapper":"On-z"};